export enum LiveStreamingStateWrapTestIds {
  AVATAR_BADGE_IS_LIVE = 'live-streaming-state-avatar-badge-is-live',
  AVATAR_BADGE_WAS_LIVE = 'live-streaming-state-avatar-badge-was-live',
}
